import useVisibleEmployeesSchedules from "@/pages/human-resources/time-management/model/schedule-view/useVisibleEmployeesSchedules.ts";
import { useCallback } from "react";
import useCollapsedEmployeesGroups from "@/pages/human-resources/time-management/schedules/site-schedule/grouped-rows/collapsing/useCollapsedEmployeesGroups.ts";
import useScheduleViewFilters from "@/pages/human-resources/time-management/components/display-filters/provider/useScheduleViewFilters.ts";

/**
 * Tries to reveal an employee by id.
 * @return true if it was revealed, false otherwise
 */
export default function useRevealEmployeeById(): (
  employeeId: string,
) => boolean {
  const visibleSchedules = useVisibleEmployeesSchedules();
  const { collapsedGroups, dispatchCollapsed } = useCollapsedEmployeesGroups();
  const {
    state: { viewArrangement },
  } = useScheduleViewFilters();

  return useCallback(
    (employeeId: string): boolean => {
      const contract = visibleSchedules
        .find((es) => es.employee.id === employeeId)
        ?.employee.mainSiteFirstContract();

      if (contract === undefined) return false;

      switch (viewArrangement) {
        case "section":
          if (collapsedGroups.sectionsIds.has(contract.sectionId)) {
            dispatchCollapsed({
              type: "setSectionCollapsed",
              sectionId: contract.sectionId,
              collapsed: false,
            });
            return true;
          }
          break;
        case "role":
          if (collapsedGroups.rolesIds.has(contract.roleId)) {
            dispatchCollapsed({
              type: "setRoleCollapsed",
              roleId: contract.roleId,
              collapsed: false,
            });
            return true;
          }
          break;
        default:
          return false;
      }
      return false;
    },
    [
      collapsedGroups.rolesIds,
      collapsedGroups.sectionsIds,
      dispatchCollapsed,
      viewArrangement,
      visibleSchedules,
    ],
  );
}
